import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import "./index.css";

/**
 * App Component
 *
 * Root component that sets up the router.
 * AuthProvider is included in the root route layout.
 */
export function App() {
  return <RouterProvider router={router} />;
}

export default App;
